module.exports = __webpack_public_path__ + "static/media/25-fells-becca_10_18_2020.61e72d4c.jpg";